import React from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { selectedAuthor } from "../../features/filter/filterSlice";
import { removeVideo } from "../../features/updateLikeUnlike/updateLikeUnlikeSlice";

const RelatedVideoListItem = ({ videoInfo }) => {
    const { title, thumbnail, duration, author, date, views, id } =
        videoInfo || {};

    const location = useLocation();
    const navigate = useNavigate();

    const dispatch = useDispatch();

    const handleSelectedAuthor = (author) => {
        dispatch(selectedAuthor(author));

        //if user not in home page, redirect him to home page
        if (location?.pathname !== "/") {
            navigate("/");
        }
    };

    const handleDynamicRoute = () => {
        /*Removing the updateLikeUnlikeSlice state video 
        so that for the first time we can get the initial video info,
        then we can update like and unlike on every click on the UI 
        without **Rerender** the whole Component everyTime.*/
        dispatch(removeVideo());

        navigate(`/videos/${id}`);
    };

    return (
        <div className="w-full flex flex-row gap-2 mb-4">
            <div className="relative w-[168px] h-[94px] flex-none duration-300 hover:scale-[1.03]">
                <div className="cursor-pointer" onClick={handleDynamicRoute}>
                    <img src={thumbnail} className="object-cover" alt={title} />
                </div>
                <p className="absolute right-2 bottom-2 bg-gray-900 text-gray-100 text-xs px-1 py">
                    {duration}
                </p>
            </div>

            <div className="flex flex-col w-full">
                <div className="cursor-pointer" onClick={handleDynamicRoute}>
                    <p className="text-slate-900 text-sm font-semibold">
                        {title}
                    </p>
                </div>
                <div
                    className="cursor-pointer text-gray-400 text-xs mt-2 hover:text-gray-600"
                    onClick={() => handleSelectedAuthor(author)}
                >
                    {author}
                </div>
                <p className="text-gray-400 text-xs mt-1">
                    {views} views . {date}
                </p>
            </div>
        </div>
    );
};

export default RelatedVideoListItem;
